import { useQuery } from '@tanstack/react-query';
import { QUESTIONNAIRE_ANSWERS_KEY } from '../../utils/constants/queryKeys';
import { getQuestionnaireAnswers } from '../services/fn-api/Questionnaires';

export const useGetQuestionnaireAnswers = (caseQuestionnaireId: number) => {
  return useQuery({
    queryKey: [QUESTIONNAIRE_ANSWERS_KEY, caseQuestionnaireId],
    queryFn: () => getQuestionnaireAnswers(caseQuestionnaireId),
    enabled: !!caseQuestionnaireId,
  });
};
